import ExtensionAggregationStore from 'stores/extensionResult/ExtensionAggregationStore';
import BaseListStore from 'stores/BaseListStore';
import getAnalysisContext from '../../helpers/getAnalysisContext';
import { getConditions, getListConditions } from 'stores/_services/filterService';
import { buildOptions, getPage } from 'stores/_services/dataService';
import log from 'services/helpers/log';
import { action, makeObservable } from 'mobx';
import { buildCsvDownloadUrl } from 'stores/_services/downloadService';
import { SortDirection } from 'constants/SortDirection';

const SEARCH_FIELDS = ['name'];

export default class ExtensionAggregationListStore extends BaseListStore<ExtensionAggregationStore> {
    private readonly baseRoute: string = 'extensions';
    constructor() {
        super({
            itemStore: ExtensionAggregationStore,
            sortBy: 'hitCount',
            sortDirection: SortDirection.DESC
        });

        makeObservable(this, {
            getExtensionAggregation: action
        });
    }

    async getExtensionAggregation(args: any): Promise<void> {
        const { boxId, route } = await getAnalysisContext(this.baseRoute);
        const shouldReset = this._updateListState(args);

        const conditions: any[] = getConditions(this.filter);

        conditions.push({ boxId });

        const options = {
            filter: {
                limit: this.limit,
                skip: this.skip,
                searchFields: SEARCH_FIELDS,
                where: conditions,
                order: this.sort
            }
        };

        let res;

        try {
            res = await getPage(route, options);
        } catch (e) {
            return log.error(e as Error);
        }

        const { data } = res;

        if (shouldReset) {
            this.clearIds();
        }

        this._updateData(data);
        this._updateIds(data, this.skip);
        this._updateCount(data);
    }

    public async exportToCsv(): Promise<void> {
        const { boxId, analysisFilter, route } = await getAnalysisContext(this.baseRoute);
        const conditions = getListConditions(this.selectedIdList, this.filter);

        if (analysisFilter) {
            conditions.push(analysisFilter);
        }

        if (boxId) {
            conditions.push({ boxId });
        }

        const options = {
            filter: {
                searchFields: SEARCH_FIELDS,
                where: conditions,
                order: this.sort
            },
            excludeFields: ['fileRepId', 'id', 'flagId', 'boxId']
        };

        const query = buildOptions(options);

        try {
            window.location.href = await buildCsvDownloadUrl(route, query);
        } catch (e) {
            log.error(e as Error);
        }
    }
}
